module.exports = __webpack_public_path__ + "img/copilot.7a8b549b.svg";